// Скопировано из clown-back через `pnpm api`. Не править руками.
// Code generated by tygo. DO NOT EDIT.
// Сгенерировано из internal/handler/ws/protocol через `make api-ws`. Не править руками.
import type { Command, Event, PublicState } from "./game";

//////////
// source: messages.go
/*
Package protocol описывает формат сообщений игрового WebSocket-протокола.

Пакет намеренно отделён от транспорта: здесь только типы. Из них через tygo
генерируются TypeScript-типы для clown-client, поэтому руками на двух языках
эти структуры не поддерживаются — они разъедутся молча.

OpenAPI сюда не дотягивается: он не описывает WebSocket, а по нему идёт весь
ход партии. Человекочитаемая часть контракта живёт в api/ws-protocol.md.
*/

/**
 * ContractVersion — семвер контракта, общий для REST и WebSocket.
 * Объявляется в хендшейке. Клиент с несовместимой мажорной версией обязан
 * получить внятную ошибку, а не молчаливую поломку на третьем ходу.
 */
export const ContractVersion = "0.1.0";
/**
 * ClientMessageType — тип сообщения от клиента.
 */
export type ClientMessageType = string;
/**
 * Сообщения от клиента.
 */
export const ClientHello: ClientMessageType = "hello";
/**
 * Сообщения от клиента.
 */
export const ClientCommand: ClientMessageType = "command";
/**
 * Сообщения от клиента.
 */
export const ClientPing: ClientMessageType = "ping";
/**
 * ClientLeave — выход из комнаты (ADR-0011 §8).
 * Не игровая команда: журнала он не пишет и редьюсера не касается,
 * поэтому и живёт отдельным типом сообщения, а не значением game.Command.
 * Игроку разрешён только в лобби; хосту — в любой стадии, и он закрывает
 * комнату целиком.
 */
export const ClientLeave: ClientMessageType = "leave";
/**
 * ServerMessageType — тип сообщения от сервера.
 */
export type ServerMessageType = string;
/**
 * Сообщения от сервера.
 */
export const ServerHelloOK: ServerMessageType = "hello_ok";
/**
 * Сообщения от сервера.
 */
export const ServerState: ServerMessageType = "state";
/**
 * Сообщения от сервера.
 */
export const ServerEvents: ServerMessageType = "events";
/**
 * Сообщения от сервера.
 */
export const ServerError: ServerMessageType = "error";
/**
 * Сообщения от сервера.
 */
export const ServerPong: ServerMessageType = "pong";
/**
 * Сообщения от сервера.
 */
export const ServerClosed: ServerMessageType = "closed";
/**
 * ErrorCode — машиночитаемая причина отказа.
 */
export type ErrorCode = string;
/**
 * Коды ошибок.
 */
export const ErrCodeBadContract: ErrorCode = "bad_contract"; // несовместимая версия контракта
/**
 * Коды ошибок.
 */
export const ErrCodeUnauthorized: ErrorCode = "unauthorized"; // нет валидной сессии
/**
 * Коды ошибок.
 */
export const ErrCodeNoRoom: ErrorCode = "no_room"; // комнаты не существует или она умерла
/**
 * Коды ошибок.
 */
export const ErrCodeNotAllowed: ErrorCode = "not_allowed"; // отправитель не владеет местом
/**
 * Коды ошибок.
 */
export const ErrCodeBadCommand: ErrorCode = "bad_command"; // команда не подходит стадии хода
/**
 * Коды ошибок.
 */
export const ErrCodeInternal: ErrorCode = "internal";
/**
 * ClientEnvelope — конверт сообщения от клиента.
 * ID проставляет клиент; сервер возвращает его в ответе, чтобы клиент мог
 * связать отказ с конкретным нажатием кнопки.
 */
export interface ClientEnvelope {
  type: ClientMessageType;
  id?: string;
  payload?: unknown;
}
/**
 * ServerEnvelope — конверт сообщения от сервера.
 */
export interface ServerEnvelope {
  type: ServerMessageType;
  replyTo?: string;
  payload?: unknown;
}
/**
 * HelloPayload — первое сообщение клиента.
 * Сессия передаётся здесь, а не в query-строке: query попадает в логи nginx.
 */
export interface HelloPayload {
  contractVersion: string;
  token: string;
  roomCode: string;
}
/**
 * HelloOKPayload — подтверждение хендшейка.
 * Seats — места, которыми владеет это соединение: одно в режиме multi и все
 * сразу в hotseat. Клиент по нему понимает, чьи кнопки ему показывать.
 */
export interface HelloOKPayload {
  contractVersion: string;
  roomCode: string;
  roomMode: RoomMode;
  seats: number /* int */[];
  state: PublicState;
}
/**
 * RoomMode — как соединение связано с местами за столом.
 */
export type RoomMode = string;
/**
 * Режимы комнаты.
 */
export const RoomMulti: RoomMode = "multi"; // у каждого своё устройство
/**
 * Режимы комнаты.
 */
export const RoomHotseat: RoomMode = "hotseat"; // одно устройство передают по кругу
/**
 * CommandPayload — намерение игрока.
 * Клиент шлёт только намерения. Право проверяет сервер: «отправитель владеет
 * местом активного игрока», а не «отправитель и есть активный игрок» — иначе
 * hotseat, где одно соединение держит все места, не работал бы.
 */
export interface CommandPayload {
  command: Command;
}
/**
 * StatePayload — состояние глазами получателя.
 * Каждому соединению уходит СВОЯ редакция. Общее состояние одним сообщением
 * всем не рассылается никогда: в hotseat сюда кладётся редакция активного
 * игрока, потому что телефон в руках у него.
 */
export interface StatePayload {
  state: PublicState;
}
/**
 * EventsPayload — что произошло с момента прошлого состояния.
 * Нужен для анимаций и подсветки: состояние отвечает на вопрос «как сейчас»,
 * события — «что случилось».
 */
export interface EventsPayload {
  events: Event[];
}
/**
 * ErrorPayload — отказ.
 */
export interface ErrorPayload {
  code: ErrorCode;
  message: string;
}
/**
 * ClosedPayload — комната закрыта.
 */
export interface ClosedPayload {
  reason: string;
}
